/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
import styled from 'styled-components'
import { Anchor, Theme, Loader } from '@nexigendigital/nxui'
import { WEIGHT } from 'helpers/constants'

export const Authentication = {
    Base: styled.div`
         display: flex;
         align-items: center;
         justify-content: center;
         flex-direction: column;
         flex-shrink: 0;
         height: 100%;
         width: 100%;
         background-color: ${props => (props.theme['background--300'])};
    `,
    Wrapper: styled.div`
         display: inline-flex;
         align-items: center;
         justify-content: center;
         border-radius: 16px;

        ${(props) => Theme.Functions.mediaBreakDown(props.theme['breakpoints-md'])} {
			flex-direction: column;
            padding: 0 15px;
		}
    `,
    Form: styled.div`
        position: relative;
        right: 7px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        width: 425px;
        border-radius: 16px;
        background-color: ${props => (props.theme['background--000'])};

        ${(props) => Theme.Functions.mediaBreakDown(props.theme['breakpoints-md'])} {
            right: unset;
            width: 100%;
            border-radius: 0 0 16px 16px;
		}
 
    `,
    Transition: styled.div`
        display: flex;
        flex-direction: column;
        width: 100%;
    `,
    Loading: styled(Loader)`
        position: relative;
        bottom: 20px;
        min-height: 220px;
    `,
    Company: styled.div`
        position: relative;
        left: 7px;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        padding: 90px 40px;
        border-radius: 16px;
        background-color: ${props => (props.theme['background--200'])};

        ${(props) => Theme.Functions.mediaBreakDown(props.theme['breakpoints-md'])} {
			left: unset;
            align-items: center;
            width: 100%;
            padding: 30px 30px 5px;
            border-radius: 16px 16px 0 0;
            background-color: ${props => (props.theme['background--000'])};
		}
    `,
    Logo: styled.div`
         display: inline-flex;
         align-items: flex-start;
         justify-content: center;
         height: 100%;
         right: 7px;
         position: relative;
    `,
    Footer: styled.footer`
        position: absolute;
        bottom: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        color: ${props => (props.theme['text--100'])};
        font-size: 12px;
        letter-spacing: -0.25px;
        ${Theme.Functions.setFont('Inter', WEIGHT.SEMI_BOLD)};
    `,
    Anchor: styled(Anchor)`
         margin: 5px 0 20px;
         color: ${props => (props.theme['text--100'])};
      `,
    Title: styled.p`
        position: relative;
        right: 7px;
        position: relative;
        height: 100%;
        margin-top: 0.35rem;
        text-align: center;
        font-size: 14px;
        letter-spacing: -0.25px;
        color: ${props => (props.theme['text--100'])};
        ${Theme.Functions.setFont('Inter', WEIGHT.SEMI_BOLD)};
    `,
    Ext: styled.div`
        border-radius: 0 16px 16px 0;
        background-color: ${props => (props.theme['background--400'])};
    `,
    Subtitle: styled.div`
        padding: 20px;

        p {
            color: ${props => (props.theme['text--100'])};
        }
    `
}
